module.exports = __webpack_public_path__ + "media/images/homes/StockNotifications-08fe3f5bc3ad412ad67ec60c94a710f0.png";